'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../../utils/cn';
const Sidebar = forwardRef(({ className, children, ...props }, ref) => {
    return (_jsx("aside", { ...props, ref: ref, className: cn('flex h-[calc(100vh-25vh)] w-[280px] flex-col justify-between rounded-xl border border-metal-100 bg-white p-5 shadow-xl dark:border-metal-900 dark:bg-metal-900', className), children: children }));
});
Sidebar.displayName = 'Sidebar';
export { Sidebar };
